import { render, staticRenderFns } from "./CourseVideoInfo.vue?vue&type=template&id=2cdfc4c1&scoped=true&"
import script from "./CourseVideoInfo.vue?vue&type=script&lang=js&"
export * from "./CourseVideoInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideoInfo.vue?vue&type=style&index=0&id=2cdfc4c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdfc4c1",
  null
  
)

export default component.exports